/* Flick · Ficha de producto — galería, selección de variantes y carrito
 * Compatible con productos Shopify de alta cardinalidad (>250 variantes).
 * La disponibilidad y la variante seleccionada se resuelven en Shopify mediante
 * product_option_value + option_values + Section Rendering API.
 */
(function () {
  var P = window.fkProductI18n || {};

  function init(root) {
    if (!root || root.dataset.fkReady) return;
    root.dataset.fkReady = '1';

    var form = root.querySelector('#fk-pdp-form');
    var idInput = root.querySelector('[data-fk-variant-id]');
    var addBtn = root.querySelector('[data-fk-add]');
    var addTxt = root.querySelector('[data-fk-add-txt]');
    var hint = root.querySelector('[data-fk-hint]');
    var nowEl = root.querySelector('[data-fk-now]');
    var wasEl = root.querySelector('[data-fk-was]');
    var offEl = root.querySelector('[data-fk-off]');
    var stockWrap = root.querySelector('[data-fk-stock]');
    var stockTxt = root.querySelector('[data-fk-stock-txt]');
    var deliveryWrap = root.querySelector('[data-fk-delivery]');
    var deliveryTxt = root.querySelector('[data-fk-delivery-txt]');
    var mainImgs = root.querySelectorAll('.fk-pdp-mainimg');
    var optGroups = root.querySelectorAll('[data-fk-opt]');

    var sectionId = root.dataset.sectionId;
    var productUrl = root.dataset.productUrl || window.location.pathname;
    var currentVariant = readVariantMeta(root);
    var abortController = null;
    var requestSerial = 0;

    function readVariantMeta(scope) {
      var el = scope && scope.querySelector('[data-fk-current-variant]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.error('[Flick PDP] No se pudo leer la variante actual.', e);
        return null;
      }
    }

    /* ---------- galería ---------- */
    function showSlide(i) {
      root.querySelectorAll('.fk-pdp-thumb').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.fkThumb == i);
      });
      mainImgs.forEach(function (m) {
        m.classList.toggle('is-active', m.dataset.fkSlide == i);
      });
    }

    root.querySelectorAll('[data-fk-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        showSlide(t.dataset.fkThumb);
      });
    });

    /* ---------- cantidad ---------- */
    var qInput = root.querySelector('[data-fk-qty-input]');
    root.querySelectorAll('[data-fk-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var val = parseInt(qInput.value, 10) || 1;
        val = Math.max(1, val + parseInt(b.dataset.fkQty, 10));
        qInput.value = val;
      });
    });

    /* ---------- variantes (>250 compatibles) ---------- */
    function selectedOptionValueIds() {
      var ids = [];

      for (var i = 0; i < optGroups.length; i++) {
        var selectedBtn = optGroups[i].querySelector('[data-fk-value][aria-checked="true"]');
        if (!selectedBtn || !selectedBtn.dataset.optionValueId) return null;
        ids.push(selectedBtn.dataset.optionValueId);
      }

      return ids;
    }

    function setLoading(isLoading) {
      root.toggleAttribute('data-fk-loading', !!isLoading);
      if (!addBtn) return;

      if (isLoading) {
        addBtn.disabled = true;
      } else if (currentVariant) {
        addBtn.disabled = !currentVariant.available;
      } else {
        addBtn.disabled = true;
      }
    }

    function syncOptionButtons(freshRoot) {
      if (!freshRoot) return;

      optGroups.forEach(function (group) {
        var pos = group.dataset.fkOpt;
        var freshGroup = freshRoot.querySelector('[data-fk-opt="' + pos + '"]');
        if (!freshGroup) return;

        var freshById = {};
        freshGroup.querySelectorAll('[data-fk-value][data-option-value-id]').forEach(function (freshBtn) {
          freshById[freshBtn.dataset.optionValueId] = freshBtn;
        });

        group.querySelectorAll('[data-fk-value][data-option-value-id]').forEach(function (btn) {
          var freshBtn = freshById[btn.dataset.optionValueId];
          if (!freshBtn) return;

          btn.setAttribute('aria-checked', freshBtn.getAttribute('aria-checked') === 'true' ? 'true' : 'false');

          if (freshBtn.hasAttribute('data-unavailable')) {
            btn.setAttribute('data-unavailable', '');
          } else {
            btn.removeAttribute('data-unavailable');
          }

          btn.disabled = freshBtn.disabled;
        });
      });
    }

    function renderVariant(v) {
      currentVariant = v || null;

      if (v) {
        if (idInput) idInput.value = v.id;
        if (nowEl) nowEl.textContent = v.price || '';

        if (v.has_compare) {
          if (wasEl) {
            wasEl.textContent = v.compare || '';
            wasEl.hidden = false;
          }
          if (offEl) {
            offEl.textContent = '-' + v.pct + '%';
            offEl.hidden = false;
          }
        } else {
          if (wasEl) wasEl.hidden = true;
          if (offEl) offEl.hidden = true;
        }

        if (stockWrap && stockTxt) {
          if (v.available) {
            stockWrap.removeAttribute('data-out');
            stockTxt.textContent = v.low
              ? (P.stock_last || 'Últimas unidades en stock')
              : (P.in_stock || 'En stock');
          } else {
            stockWrap.setAttribute('data-out', '');
            stockTxt.textContent = P.sold_out || 'Agotado';
          }
        }

        if (addBtn) addBtn.disabled = !v.available;
        if (addTxt) addTxt.textContent = v.available
          ? (P.add_to_cart || 'Añadir al carrito')
          : (P.sold_out || 'Agotado');
        if (hint) hint.hidden = true;

        if (v.media != null) showSlide(v.media);

        if (deliveryWrap && deliveryTxt) {
          var pt = v.plazo === 'tienda'
            ? (P.plazo_tienda || '')
            : (v.plazo === 'marca' ? (P.plazo_marca || '') : '');

          if (pt) {
            deliveryTxt.textContent = pt;
            deliveryWrap.hidden = false;
          } else {
            deliveryWrap.hidden = true;
          }
        }
      } else {
        if (idInput) idInput.value = '';
        if (addBtn) addBtn.disabled = true;
        if (addTxt) addTxt.textContent = P.sold_out || 'Agotado';
        if (stockWrap) stockWrap.setAttribute('data-out', '');
        if (stockTxt) stockTxt.textContent = P.sold_out || 'Agotado';
        if (deliveryWrap) deliveryWrap.hidden = true;
      }
    }

    function buildVariantRequestUrl(optionValueIds) {
      var url = new URL(productUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('option_values', optionValueIds.join(','));
      return url.toString();
    }

    function fetchVariantState(focusBtn) {
      var optionValueIds = selectedOptionValueIds();
      if (!optionValueIds || optionValueIds.length !== optGroups.length) {
        currentVariant = null;
        if (idInput) idInput.value = '';
        if (addBtn) addBtn.disabled = true;
        if (hint) hint.hidden = false;
        return;
      }

      if (abortController) abortController.abort();
      abortController = new AbortController();
      var serial = ++requestSerial;

      // Desde este momento la selección visual ya ha cambiado. No mantenemos
      // una variante anterior como comprable mientras llega la respuesta.
      currentVariant = null;
      if (idInput) idInput.value = '';
      setLoading(true);

      fetch(buildVariantRequestUrl(optionValueIds), {
        signal: abortController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (htmlText) {
          if (serial !== requestSerial) return;

          var doc = new DOMParser().parseFromString(htmlText, 'text/html');
          var freshRoot = doc.querySelector('[data-fk-pdp]');
          if (!freshRoot) throw new Error('No se encontró el bloque Flick PDP en la respuesta.');

          syncOptionButtons(freshRoot);
          renderVariant(readVariantMeta(freshRoot));

          if (focusBtn && document.contains(focusBtn)) {
            focusBtn.focus({ preventScroll: true });
          }
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          console.error('[Flick PDP] Error actualizando la variante.', error);
          if (hint) {
            hint.textContent = P.add_fail || 'No se pudo actualizar la selección. Inténtalo de nuevo.';
            hint.hidden = false;
          }
        })
        .finally(function () {
          if (serial === requestSerial) setLoading(false);
        });
    }

    root.querySelectorAll('[data-fk-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        var group = btn.closest('[data-fk-opt]');
        if (!group) return;

        group.querySelectorAll('[data-fk-value]').forEach(function (b) {
          b.setAttribute('aria-checked', 'false');
        });
        btn.setAttribute('aria-checked', 'true');

        fetchVariantState(btn);
      });
    });

    // El servidor ya devuelve la selección inicial correcta mediante
    // product_option_value.selected. No recorremos product.variants.
    renderVariant(currentVariant);

    /* ---------- añadir al carrito (AJAX) ---------- */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var optionValueIds = selectedOptionValueIds();
        if (!currentVariant || !currentVariant.id || !optionValueIds || optionValueIds.length !== optGroups.length) {
          if (hint) {
            hint.hidden = false;
            hint.scrollIntoView({ block: 'nearest' });
          }
          return;
        }

        if (!currentVariant.available) return;

        addBtn.disabled = true;
        addTxt.textContent = P.adding || 'Añadiendo…';

        var qty = parseInt(qInput.value, 10) || 1;
        var done = function () {
          addBtn.disabled = false;
          addTxt.textContent = P.add_to_cart || 'Añadir al carrito';
        };
        var fail = function (msg) {
          done();
          hint.textContent = msg || (P.add_fail || 'No se pudo añadir. Inténtalo de nuevo.');
          hint.hidden = false;
        };

        // si existe el cart drawer, abrimos el drawer en vez de ir a /cart
        if (window.FlickCart && typeof window.FlickCart.add === 'function') {
          window.FlickCart.add(idInput.value, qty)
            .then(function (res) {
              if (res && res.ok) {
                done();
                addTxt.textContent = P.added || 'Añadido ✓';
                setTimeout(function () {
                  addTxt.textContent = P.add_to_cart || 'Añadir al carrito';
                }, 1500);
              } else {
                fail(res && res.j && res.j.description);
              }
            })
            .catch(function () {
              fail();
            });
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: idInput.value, quantity: qty })
        })
          .then(function (r) {
            return r.json().then(function (j) {
              return { ok: r.ok, j: j };
            });
          })
          .then(function (res) {
            if (res.ok) {
              window.location.href = '/cart';
            } else {
              fail(res.j && res.j.description);
            }
          })
          .catch(function () {
            fail();
          });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-fk-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
